export interface CompressionOptions {
  maxSizeMB?: number;
  useWebWorker?: boolean;
  initialQuality?: number;
  maxWidthOrHeight?: number;
}

let imageCompression: any = null;

async function loadImageLibraries() {
  if (!imageCompression) {
    const imageCompressionModule = await import('browser-image-compression');
    imageCompression = imageCompressionModule.default;
  }
}

export async function compressImage(file: File, options: CompressionOptions = {}): Promise<File> {
  // Skip client-side processing for HEIC files - let the server handle conversion
  // The server uses Imagick which supports newer HEIC formats better than client-side libraries
  if (file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
    return file;
  }

  const MIN_COMPRESSION_BYTES = 200 * 1024;
  if (file.size <= MIN_COMPRESSION_BYTES) {
    return file;
  }

  await loadImageLibraries();

  const defaultOptions = {
    maxSizeMB: 0.5,
    useWebWorker: true,
    initialQuality: 0.9,
    maxWidthOrHeight: 800,
  };

  const compressionOptions = { ...defaultOptions, ...options };

  return imageCompression(file, compressionOptions);
}

export { loadImageLibraries };
